import RoleList from "./components/List"
import RoleForm from "./components/Form"
import RolePermissions from "./components/Permissions"

const meta = {
  module: "roles"
}

let module = "roles"

export default [
  {
    path: "roles",
    component: RoleList,
    meta: { module: module, permissions: ["role-access"] }
  },
  {
    path: "roles/create",
    component: RoleForm,
    props: true,
    meta: { module: module, permissions: ["role-create"] }
  },
  {
    path: "roles/edit/:id",
    component: RoleForm,
    props: true,
    meta: { module: module, permissions: ["role-edit"] }
  },
  {
    path: "roles/permissions/:id",
    component: RolePermissions,
    props: true,
    meta: { module: module, permissions: ["role-edit"] }
  }
]
